<template>
  <hm-content title="">
    <div class="temp-header flex flex-between">
      <div @click="$router.back(-1)" class="btn">
        <span class="hmicon icon-fanhui"></span>
        返回
      </div>
      <div></div>

      <div class="flex">
        <div class="mr10" v-if="queryType">
          当前状态: 
          <span class="primary" v-if="queryType === 'waitAudit'">待审核</span>
          <span class="primary" v-else-if="queryType === 'supplier'">复核中</span>
        </div>
        <div class="mr10" v-if="orderType">
          <span class="primary" v-if="orderType === 'normal'">普通单</span>
          <span class="primary" v-else-if="orderType === 'month'">月结单</span>
        </div>
        <div class="mr10" v-if="queryStartTime">
          {{ queryStartTime }} 至 {{ queryEndTime }}
        </div>
        <div v-if="provinceName">
          当前省份: <span class="primary">{{ provinceName }}</span>
        </div>
      </div>
    </div>
    <div class="flex flex-end">
      <div
        v-for="(v, i) in sort"
        :key="i"
        @click="sortList(v)"
        class="mr10 pointer"
        :class="{ primary: selectSort.prop === v.prop }"
      >
        {{ v.title }}
        <i class="el-icon-sort" v-if="selectSort.prop !== v.prop"></i>
        <i
          class="el-icon-sort-down"
          v-else-if="
            selectSort.prop === v.prop && selectSort.order === 'ascending'
          "
        ></i>
        <i
          class="el-icon-sort-up"
          v-else-if="
            selectSort.prop === v.prop && selectSort.order === 'descending'
          "
        ></i>
      </div>
    </div>
    <div class="table mt10">
      <el-row :gutter="10">
        <el-col
          :xs="12"
          :sm="12"
          :md="6"
          :lg="6"
          :xl="6"
          class="mb20"
          v-for="(v, i) in salesVolumeList.records"
          :key="i"
        >
          <el-card
            @click.native="details(v)"
            shadow="hover"
            class="card pointer"
            :body-style="{ padding: '0px' }"
            :style="v.backgroundImage"
          >
            <div slot="header" class="text-overflow ">
              <el-tooltip :content="v.storeName" placement="top">
                <span> {{ v.storeName }}</span>
              </el-tooltip>
            </div>
            <div class="flex flex-between p10">
              <div class="shengheType">
                <p class="tit">销量申报待审核</p>
                <p style="marginTop:10px;color: rgba(255, 255, 255, 1);">
                  <span class="titval"> {{ v.watiNum }}</span>
                  <span>单</span>
                </p>
              </div>
              <div style="font-size:14px" class=" flex flex-column flex-center">
                <div class="text-right">
                  最早申报时间:
                </div>
                <div>
                  {{ v.minDeclareTime }}
                </div>
              </div>
            </div>
          </el-card>
        </el-col>
      </el-row>
      <div class="hm-pagination" v-if="salesVolumeList.total">
        <el-pagination
          background
          :total="salesVolumeList.total"
          @current-change="paging"
          @size-change="handleSizeChange"
          layout="total,sizes,  prev, pager, next, jumper"
          :current-page="currentPage"
          :page-size="pageSize"
        ></el-pagination>
      </div>
      <div v-else>
        暂无数据.......
      </div>
    </div>
  </hm-content>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  components: {},
  data() {
    return {
      selectSort: {
        title: "",
        order: "",
        prop: ":"
      },
      sort: [
        {
          title: "按时间排序",
          order: "",
          prop: "minDeclareTime"
        },
        {
          title: "按单量排序",
          order: "",
          prop: "watiNum"
        }
      ],
      currentPage: 1,
      pageSize: 20,
      provinceName: "",
      queryStartTime: "",
      queryEndTime: "",
      declareVersion: "",
      queryType: "",
      orderType: "",
    };
  },
  computed: {
    ...mapGetters([
      "salesVolumeList"
      //   "declareList",
      //   "detailsDeclare",
      //   "backDeclareCount",
      //   "detailsSalesVolume",
      //   "queryProvinceList"
    ])
  },
  watch: {},
  created() {},
  mounted() {
    this.provinceName = localStorage.getItem("provinceName");
    let queryTime = JSON.parse(localStorage.getItem("queryTime"));
    this.queryStartTime = queryTime.queryStartTime;
    this.queryEndTime = queryTime.queryEndTime;
    if (this.$route.query.declareVersion) {
      this.declareVersion = this.$route.query.declareVersion;
    }
    if(this.$route.query.queryType){
      this.queryType = this.$route.query.queryType;
    }
    if(this.$route.query.orderType){
      this.orderType = this.$route.query.orderType;
    }

    this.queryList();
  },
  methods: {
    sortList(selectSort) {
      switch (selectSort.order) {
        case "ascending":
          selectSort.order = "descending";
          break;
        case "descending":
          selectSort.order = "ascending";
          break;
        default:
          selectSort.order = "ascending";
      }
      this.selectSort = selectSort;
      this.queryList();
    },
    queryList() {
      let params = {
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        storeProvince: this.$route.query.storeProvince,
        queryType: this.queryType,
        orderType: this.orderType,
        queryStartTime: this.queryStartTime,
        queryEndTime: this.queryEndTime,
        declareVersion: this.declareVersion
      };
      Object.assign(params, this.selectSort);
      return this.$store.dispatch("querySalesVolumeList", params);
    },
    details(v) {
      localStorage.setItem("sh", v.storeName);
      // this.$router.push({
      //   name: "DetailsSalesVolume",
      //   query: {
      //     storeCode: v.storeCode
      //   }
      // });
      this.$router.push({
        name: "DetailsSalesVolumeNew",
        query: {
          storeCode: v.storeCode,
          queryStartTime: this.queryStartTime,
          queryEndTime: this.queryEndTime,
          declareVersion: this.declareVersion,
          queryType: this.queryType,
          orderType: this.orderType,
        }
      });
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    }
  }
};
</script>
<style lang="scss" scoped>
.grid-contents {
  box-shadow: 0px 0px 18px 0px rgba(230, 230, 230, 1);
  border-radius: 6px;
  .hr {
    height: 1px;
    background: rgba(255, 255, 255, 1);
    opacity: 0.7;
  }
  .companyTitle {
    font-weight: 500;
    color: rgba(255, 255, 255, 1);
    font-size: 18px;
    padding: 10px 0 10px 30px;
    // width: 200px;
  }
  .shengheType {
    .tit {
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 500;
      color: rgba(255, 255, 255, 1);
    }
    .titval {
      font-size: 30px;
      font-family: PingFang SC;
      font-weight: 400;
      margin-top: 10px;
    }
  }
}

.card {
  color: #fff;
  font-size: 18px;
  border-radius: 6px;
  .shengheType {
    padding: 10px 0;
    .tit {
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 500;
      color: rgba(255, 255, 255, 1);
    }
    .titval {
      font-size: 30px;
      font-family: PingFang SC;
      font-weight: 400;
      margin-top: 10px;
    }
  }
}

.temp-header {
  height: 50px;
  line-height: 50px;
  background: rgba(255, 255, 255, 1);
  color: #000;
  // padding: 0 22px;
  font-size: 16px;
  user-select: none;
  .hmicon {
    color: #e50065;
    font-size: 18px;
  }
  .btn {
    cursor: pointer;
  }
  .title {
    font-size: 18px;
  }
  .sub-title {
    font-size: 14px;
  }
  .header-list {
    li {
      border-right: 1px solid #fff;
      padding: 0 22px;
    }
    li:last-child {
      padding-right: 0;
      border-right: 0;
    }
  }
}
</style>
